import * as PIXI from "pixi.js"

export const createApp = () => {

    return new PIXI.Application({
        width: window.innerWidth,
        height: window.innerHeight,
        resolution: window.devicePixelRatio,
        autoDensity: true,
        antialias: false,
        preserveDrawingBuffer: false,
        clearBeforeRender: false,
        // transparent: false,
        // backgroundAlpha: 0
        // powerPreference: 'low-power'
        // clearBeforeRender: false
    })
}



// width?: number;
// height?: number;
// view?: HTMLCanvasElement;
// useContextAlpha?: boolean | 'notMultiplied';
// /**
//  * Use `backgroundAlpha` instead.
//  * @deprecated
//  */
// transparent?: boolean;
// autoDensity?: boolean;
// antialias?: boolean;
// resolution?: number;
// preserveDrawingBuffer?: boolean;
// clearBeforeRender?: boolean;
// backgroundColor?: number;
// backgroundAlpha?: number;
// powerPreference?: WebGLPowerPreference;
// context?: IRenderingContext;